<template>
    <div>
        <sparator v-show="showSparatorButton"></sparator>
        <div class="relative overflow-hidden">
            <picture class="w-full z-0">
                <source
                    media="(max-width: 768px)"
                    srcset="storage/pages/who-we-are/bg-landing-page-mobile.png"
                />
                <img
                    src="storage/pages/who-we-are/bg-landing-page.png"
                    alt=""
                    class="w-full"
                />
            </picture>
            <div
                class="w-full h-full absolute top-0 left-0 z-10 flex items-center md:items-start md:pt-300"
            >
                <div
                    class="w-full mx-150 md:mx-50 flex items-center justify-between md:justify-center "
                >
                    <div
                        class="text-black text-40 font-semibold pl-150 md:pl-0"
                    >
                        What
                    </div>
                    <div
                        class="text-black text-40 font-semibold pr-150 md:pr-0 md:pl-10"
                    >
                        We Are Facing
                        <span class="text-green-500 text-5xl">.</span>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="mx-150 md:mx-50 py-150 ">
                <div>
                    <div
                        class="flex  relative pb-40 pt-40 border-b-1 border-t border-gray-500 md:flex-wrap md:items-center"
                    >
                        <div class="w-2/12 mx-60 md:mx-0 md:w-5/12">
                            <img
                                src="storage/pages/who-we-are/flat-mountain.png"
                                alt=""
                                class="w-full"
                            />
                        </div>
                        <div
                            class="text-60 leading-tight  ml-40 w-4/12 font-semibold "
                        >
                            Tip of The<br />Iceberg
                        </div>
                        <div
                            class="flex-1 text-gray-600 text-20 md:w-full md:flex-none md:mt-30"
                        >
                            Many of today's problem we are facing as society are
                            being solved on the surface level. From racism to
                            corruption, from incompetencies to dictatorship, a
                            lot of these are fruit of how we / they were raised
                            in our / their families.
                        </div>
                    </div>
                    <div
                        class="flex  relative pb-40 pt-40 border-b-1 border-t border-gray-500 md:flex-wrap md:items-center"
                    >
                        <div class="w-2/12 mx-60 md:mx-0 md:w-5/12">
                            <img
                                src="storage/pages/who-we-are/flat-missed.png"
                                alt=""
                                class="w-full"
                            />
                        </div>
                        <div
                            class="text-60 leading-tight  ml-40 w-4/12 font-semibold "
                        >
                            Missed<br />opportunity
                        </div>
                        <div
                            class="flex-1 text-gray-600 text-20 md:w-full md:flex-none md:mt-30"
                        >
                            Not merely avoiding a problematic adulthood, a lot
                            of kids lose the potential of being their best self
                            because they are not raised right. Childhood's
                            physical or emotional abuse, overprotectiveness, and
                            many more are the manifesto of knowledge gap within
                            parents.
                        </div>
                    </div>
                    <div
                        class="flex  relative pb-40 pt-40  md:flex-wrap md:items-center"
                    >
                        <div class="w-2/12 mx-60 md:mx-0 md:w-5/12">
                            <img
                                src="storage/pages/who-we-are/flat-lack.png"
                                alt=""
                                class="w-full"
                            />
                        </div>
                        <div
                            class="text-60 leading-tight  ml-40 w-4/12 font-semibold "
                        >
                            Lack of<br />Parenting<br />Guidance
                        </div>
                        <div
                            class="flex-1 text-gray-600 text-20 md:w-full md:flex-none md:mt-30"
                        >
                            Parenting, as one of the toughest job in the world,
                            doesn't come with proper onboarding, instructional
                            manual or guidance. Today's source of parenting
                            knowledge does not meet current parents' busy and
                            social-media-centered lifestyle. The lack of 'easy &
                            enjoyable' experience is making its reach and
                            shareability low.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-gray-200">
            <div class="mx-150 md:mx-50 py-150  flex md:flex-col">
                <div class="flex-1 text-center px-8 md:mb-50">
                    <img
                        class="h-100 inline-block"
                        src="storage/pages/all/icon/vision.png"
                        alt=""
                    />
                    <div class="text-80 font-semibold mt-15">
                        Vision<span class="text-green-500 text-5xl ml-4"
                            >.</span
                        >
                    </div>
                    <div class="text-20 text-gray-600 mt-15">
                        To build better generations by being<br />
                        the catalyst of positive change in the<br />
                        homes of families, by providing non-exclusive expert<br />
                        knowledge and tools for their parenting journey.
                    </div>
                </div>
                <div class="flex-1 text-center px-8">
                    <img
                        class="h-100 inline-block"
                        src="storage/pages/all/icon/mission.png"
                        alt=""
                    />
                    <div class="text-80 font-semibold mt-15">
                        Mission<span class="text-green-500 text-5xl ml-4"
                            >.</span
                        >
                    </div>
                    <div class="text-20 text-gray-600 mt-">
                        To distribute practical & snackable<br />
                        content & tech tools on raising<br />
                        children to their optimum self via<br />
                        relevant medium and format.
                    </div>
                </div>
            </div>
        </div>
        <div class="o">
            <div class="mx-150 md:mx-50 py-150 ">
                <div :class="this.$css.title">
                    How We're <br />
                    Going To Do It<span :class="this.$css.titleGreen">.</span>
                </div>
                <div class="flex items-end md:flex-col md:items-start">
                    <img src="storage/pages/who-we-are/flat-how.png" alt="" />
                    <div class="pl-80 text-35 text-gray-600 md:pl-0 md:pt-80">
                        Grow a community of parents around the source of
                        knowledge that meets today's media consumption behavior
                        which are: snackable + video-based + practical,
                        distributed across popular mass-media for high
                        shareability.
                    </div>
                </div>
            </div>
        </div>
        <div class="o">
            <div class="mx-150 md:mx-50 py-150 overflow-hidden">
                <div :class="this.$css.title">
                    The Founders<span :class="this.$css.titleGreen">.</span>
                </div>
                <div class="flex -mx-50 md:-mx-0 md:flex-col">
                    <div class="flex-1 px-50 md:px-0 md:py-50 justify-center">
                        <img src="storage/pages/who-we-are/damon.png" alt="" />
                        <div class="mt-30 ml-40">
                            <div class="text-40 font-semibold">
                                Damon Hakim<span :class="this.$css.titleGreen"
                                    >.</span
                                >
                            </div>
                            <div class="text-20 text-gray-500 mb-15 italic ">
                                Pembina Yayasan
                            </div>
                            <div class="text-25 text-gray-600 mb-15">
                                Social Media/ Advertising / Tech Startups
                                Practitioner
                            </div>
                            <div class="text-35 text-gray-700 font-semibold">
                                3 Sons
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 px-50 md:px-0 md:py-50 justify-center">
                        <img src="storage/pages/who-we-are/willy.png" alt="" />
                        <div class="mt-30 ml-40">
                            <div class="text-40 font-semibold">
                                Willy B Winata<span
                                    :class="this.$css.titleGreen"
                                    >.</span
                                >
                            </div>
                            <div class="text-20 text-gray-500 mb-15 italic ">
                                Pengawas Yayasan
                            </div>
                            <div class="text-25 text-gray-600 mb-15">
                                Author, Content Specialist
                            </div>
                            <div class="text-35 text-gray-700 font-semibold">
                                2 Daughters
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 px-50 md:px-0 md:py-50 justify-center">
                        <img
                            src="storage/pages/who-we-are/yosehan.png"
                            alt=""
                        />
                        <div class="mt-30 ml-40">
                            <div class="text-40 font-semibold">
                                Yosehan Yang<span :class="this.$css.titleGreen"
                                    >.</span
                                >
                            </div>
                            <div class="text-20 text-gray-500 mb-15 italic ">
                                Pengurus Yayasan
                            </div>
                            <div class="text-25 text-gray-600 mb-15">
                                Educator, Counselor Hypnotherapist
                            </div>
                            <div class="text-35 text-gray-700 font-semibold">
                                1 Son
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="o">
            <div class="mx-150 md:mx-50 py-150 overflow-hidden">
                <div class="text-60 font-semibold text-center mb-40">
                    Our Channel<span :class="this.$css.titleGreen">.</span>
                </div>
                <div class="flex items-center justify-center -mx-20 mb-35">
                    <a
                        href="https://www.facebook.com/tanambenih/"
                        class="mx-20"
                        :class="this.$css.circleBlack"
                    >
                        <icon
                            class="w-5/12 h-auto  fill-white stroke-0"
                            name="facebook"
                        />
                    </a>
                    <a
                        href="https://twitter.com/tanambenih?lang=en"
                        class="mx-20"
                        :class="this.$css.circleBlack"
                    >
                        <icon
                            class="w-5/12 h-auto  fill-white stroke-0"
                            name="twitter"
                        />
                    </a>
                    <a
                        href="https://www.instagram.com/tanam_benih/?hl=en"
                        class="mx-20"
                        :class="this.$css.circleBlack"
                    >
                        <icon
                            class="w-5/12 h-auto  text-white"
                            name="instagram"
                        />
                    </a>
                    <a
                        href="https://www.youtube.com/channel/UCLHYVn1DxrzvV3gl2bME4wQ"
                        class="mx-20"
                        :class="this.$css.circleBlack"
                    >
                        <icon
                            class="w-5/12 h-auto  fill-white stroke-0"
                            name="youtube-white"
                        />
                    </a>
                </div>
                <div class="text-center mt-16">
                    <!-- <a href="" :class="this.$css.button">CONTACT US</a> -->
                    <inertia-link
                        @click="toggleShowButton"
                        :href="route('contactus.index')"
                        :class="this.$css.button"
                    >
                        CONTACT US</inertia-link
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Icon from "@/Shared/Icon";
import Sparator from "../../../components/Sparator.vue";

export default {
    data() {
        return {
            showSparatorButton: false
        };
    },
    metaInfo() {
        return {
            title: this.head.title
        };
    },
    layout: Layout,
    components: {
        Icon,
        Sparator
    },
    props: {
        head: Object
    },
    methods: {
        toggleShowButton() {
            this.showSparatorButton = true;
        }
    }
};
</script>
